import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const handleCardClick = () => {
    navigate(`/product/${product._id}`);
  };

  const handleAddToCart = (e) => {
    e.stopPropagation(); // 阻止事件冒泡，避免触发卡片点击
    addToCart(product);
  };

  return (
    <div className="product-card" onClick={handleCardClick}>
      <div className="product-image-container">
        <img 
          src={product.images && product.images.length > 0 ? product.images[0] : product.image || ''} 
          alt={product.name}
          className="product-image"
          loading="lazy"
        />
      </div>
      <div className="product-info">
        <div className="product-name">{product.name?.en || product.name}</div>
        <div className="product-price">${product.price}</div>
      </div>
    </div>
  );
};

export default ProductCard;
